export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M26.918 0H3.086A3.082 3.082 0 000 3.086v29.828A3.082 3.082 0 003.086 36h23.832a3.082 3.082 0 003.085-3.086V3.086A3.088 3.088 0 0026.918 0zm.524 32.163c0 .71-.576 1.276-1.275 1.276H3.837c-.71 0-1.276-.576-1.276-1.276V3.826c0-.71.576-1.275 1.276-1.275h22.33c.71 0 1.275.576 1.275 1.275v28.337zM10.728 10.275h8.547a1.275 1.275 0 100-2.55h-8.547a1.275 1.275 0 100 2.55zm1.275 15.45h7.591a1.275 1.275 0 110 2.55h-8.866c-.7 0-1.275-.565-1.275-1.275V15.007c0-.7.565-1.276 1.275-1.276h8.547a1.275 1.275 0 110 2.551h-7.272v3.446h4.444a1.275 1.275 0 110 2.55h-4.444v3.447z\" fill=\"#fa4338\"/>",
  "attrs": {
    "width": "31",
    "height": "36",
    "viewBox": "0 0 31 36",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};